import React, {useContext} from "react";
import PropTypes from 'prop-types';
import moment from 'moment';
import {Icon} from 'semantic-ui-react'
import { ReservationStatusTypes } from '../../components/shared/statustypes';
import LanguageContext from '../../language';
import './styles.less'
import { dateFormatDotted } from "../../components/shared/constants";

const ApartmentOwnerReservationItem = ({item, displayPrice}) => {
    const language = useContext(LanguageContext)
    
    const text = key=>{
        return language?language.texts[key]:key
    }
    const showAgentIcon = item.Agent && item.Agent.Icon;
    const showCompanyIcon = item.Company && item.Company.Icon;
    return (
        <div className={"reservation-item-details-wrapper"} key={item.Id}>
            <div className={"reservation-details-section"}>
                <div className={"reservation-details-title"}>
                    #{item.Number}
                </div>
                {    showAgentIcon &&
                    <div className={"reservation-item-agent"}>
                        <img src={item.Agent.Icon} className="agent-icon"/>
                    </div>
                }
                {   !showAgentIcon && showCompanyIcon &&
                    <div className={"reservation-item-agent"}>
                        <img src={item.Company.Icon} className="agent-icon"/>
                    </div>
                }
            </div>
            <div className={"reservation-details-section"}>
                <div className={"reservation-details-set"}>
                    <div className={"reservation-details-title"}>
                        {text("CheckIn")}
                    </div>
                    <div className={"reservation-item-check-in"}>
                        {moment(item.CheckInDate).format(dateFormatDotted)}
                    </div>
                </div>
                <Icon className={"reservation-item-icon"} name="arrow right" size="large"></Icon>
                <div className={"reservation-details-set"}>
                    <div className={"reservation-details-title"}>
                        {text("CheckOut")}
                    </div>
                    <div className={"reservation-item-check-in"}>
                        {moment(item.CheckOutDate).format(dateFormatDotted)}
                    </div>
                </div>
            </div>
            <div className={"reservation-details-section"}>
                <div className={"reservation-details-set"}>
                    <div className={"reservation-details-title"}>
                        {text("Guests")}
                    </div>
                    <div className={"reservation-item-check-in"}>
                        {`${item.Adults} / ${item.Children} / ${item.Infants}`}
                    </div>
                </div>
            </div>
            <div className={"reservation-details-section"}>
                <div className={"reservation-details-set"}>
                    <div className={"reservation-details-title"}>
                        {`${text("Agent")} / ${text("Company")}`}
                    </div>
                    <div className={"reservation-item-check-in"}>
                        {item.Agent && item.Agent.Name ? item.Agent.Name : "-"} / {item.Company && item.Company.Name ? item.Company.Name :"-"}
                    </div>
                </div>
            </div>
            <div className={"reservation-details-section"}>
                <div className={"reservation-details-set"}>
                    <div className={"reservation-details-title"}>
                        {text("ReservationStatus")}
                    </div>
                    <div className={"reservation-item-check-in"}>
                        {text(ReservationStatusTypes[item.StatusId])}
                    </div>
                </div>
            </div>
            {displayPrice && (
          <div className={'reservation-details-section'}>
            <div className={'reservation-details-set'}>
              <div className={'reservation-details-title'}>{text('Price')}</div>
              <div className={'reservation-item-price'}>{item.price}</div>
            </div>
          </div>
        )}
        </div>
    )
}

ApartmentOwnerReservationItem.propTypes = {
    item: PropTypes.object,
    displayPrice: PropTypes.boolean
}


export default ApartmentOwnerReservationItem;